import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PopupState, { bindTrigger, bindMenu } from 'material-ui-popup-state';
import { CircularProgress, IconButton, styled } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { useTranslation } from 'react-i18next';
import { useUserActions } from 'hooks/userContextMenu/useUserActions';
import { useNavigate } from 'react-router-dom';
import { RoutePaths } from 'constants/RoutePaths';
import { ConfirmationDialog } from 'components/ConfirmationDialog';

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
    '&:hover': {
      color: theme.palette.primary.main,
      backgroundColor: 'transparent'
    }
  }));

export const UserContextMenu = (props: { userId: string, onUserDelete: (userId: string) => void; }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);
    const [dialogMessage, setDialogMessage] = React.useState("");
    const [confirmAction, setConfirmAction] = React.useState<() => void>(() => {});
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { deleteAssignedLessons, deleteAssignedUsers, deleteUser, deletingAssignedLessons, deletingAssignedUsers, deletingUser } = useUserActions();
    
    const handleClickOpen = (message: string, action: () => void) => {
        setDialogMessage(message);
        setConfirmAction(() => action);
        setDialogOpen(true);
    };
      
    const handleConfirm = () => {
        confirmAction();
        setDialogOpen(false);
    };

    const handleDeleteUser = async (onClose: () => void) => {
        onClose();
        const resp = await deleteUser(props.userId);
        if (resp?.success) {
            props.onUserDelete(props.userId);
        }
    }
    
    const onClose = (popupState: any) => {
        popupState.close();
    }

    return (
        <PopupState variant="popover" popupId="user-context-popup-menu">
        {(popupState) => (
            <React.Fragment>
            {deletingAssignedLessons || deletingAssignedUsers || deletingUser
            ? <CircularProgress />
            :<IconButton {...bindTrigger(popupState)}>
                <MoreVertIcon />
            </IconButton>}
            <Menu {...bindMenu(popupState)}>
                <StyledMenuItem onClick={() => navigate(`${RoutePaths.PROFILE}?userId=${props.userId}`)}>{t('userDataTable.editData')}</StyledMenuItem>
                <StyledMenuItem onClick={() => navigate(`${RoutePaths.HOME}?userId=${props.userId}`)}>{t('userDataTable.seeProgress')}</StyledMenuItem>
                <StyledMenuItem onClick={() => handleClickOpen(t('userDataTable.confirmDeleteAssignedLessons'), () => { deleteAssignedLessons({ userId: props.userId}); popupState.close(); }) }>{t('userDataTable.deleteAssignedLessons')}</StyledMenuItem>
                <StyledMenuItem onClick={() => handleClickOpen(t('userDataTable.confirmDeleteAssignedUsers'), () => { deleteAssignedUsers(props.userId); popupState.close(); }) }>{t('userDataTable.deleteAssignedUsers')}</StyledMenuItem>
                <StyledMenuItem onClick={() => handleClickOpen(t('userDataTable.confirmDeleteUser'), () => handleDeleteUser(() => onClose(popupState))) }>{t('userDataTable.deleteUser')}</StyledMenuItem>
            </Menu>
            <ConfirmationDialog open={dialogOpen} handleClose={() => setDialogOpen(false)} handleConfirm={handleConfirm} message={dialogMessage}/>
            </React.Fragment>
        )}
        </PopupState>
    );
}
